import { RichTextField } from "@prismicio/client";
import { PrismicRichText } from "@prismicio/react";

import PrimaryButton from "components/button/primaryButton/PrimaryButton";

import styles from "./PagePrompt.module.scss";

export type PagePromptProps = {
  acceptText?: string;
  content?: RichTextField;
  onAccept: () => void;
  onReject: () => void;
  rejectText?: string;
  title?: string;
};

// TODO: Replace with svg from iconsax package
// or a unify icon component
export const Close = () => (
  <svg
    fill="none"
    height="16"
    viewBox="0 0 16 16"
    width="16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g stroke="#1E5751" strokeLinecap="round">
      <path d="M3 3 L13 13" />
      <path d="M13 3 L3 13" />
    </g>
  </svg>
);

const { closeButton, contentWrapper, modal, modalHeader, overlay, titleText } =
  styles;

export const PagePrompt = (props: PagePromptProps) => {
  const { acceptText, content, onAccept, onReject, rejectText, title } = props;

  if (!props.title && !props.content) {
    return null;
  }

  return (
    <>
      <div className={overlay}>
        <div className={modal}>
          <div className={modalHeader}>
            <button
              aria-label="close modal"
              className={closeButton}
              data-testid="welcomemat-close-button"
              onClick={onReject}
            >
              <Close />
            </button>
          </div>
          <div className={contentWrapper}>
            {title && <h2 className={titleText}>{title}</h2>}
            <PrismicRichText field={content} />
          </div>

          <div className={styles.actions}>
            <PrimaryButton
              as="button"
              color="green"
              onClick={onAccept}
              type="button"
            >
              {acceptText || "Confirm"}
            </PrimaryButton>

            <PrimaryButton
              as="button"
              className={styles.cancelButton}
              color="white"
              onClick={onReject}
              type="button"
            >
              {rejectText || "Cancel"}
            </PrimaryButton>
          </div>
        </div>
      </div>
    </>
  );
};
